module.exports = __webpack_public_path__ + "assets/w3-total-cache.15c83a87.svg";